module.exports = __webpack_public_path__ + "static/media/ourbusiness_F&B.63eefb4c.png";